import { useEffect, useState } from "react";

/**
 * False once the page is being left (reload, close, navigation away), true
 * again if the browser restores it from its back/forward cache. Charts key
 * their engine on it so the canvas and its series data are freed on the way out.
 */
export function usePageAlive(): boolean {
  const [alive, setAlive] = useState(true);
  useEffect(() => {
    const hide = () => setAlive(false);
    const show = () => setAlive(true);
    window.addEventListener("pagehide", hide);
    window.addEventListener("pageshow", show);
    return () => {
      window.removeEventListener("pagehide", hide);
      window.removeEventListener("pageshow", show);
    };
  }, []);
  return alive;
}
